import {gql} from '@apollo/client'

export const GET_ALL_PIPELINES = gql`
  query allPipelines(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: String
    $name: String
    $nameIcontains: String
    $nameIstartswith: String
    $organization: String
  ) {
    allPipelines(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      name: $name
      nameIcontains: $nameIcontains
      nameIstartswith: $nameIstartswith
      organization: $organization
    ) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          created
          name
          organization {
            id
            name
          }
          stagePipelineSet {
            edges {
              node {
                id
                name
                order
                stageType
              }
            }
          }
        }
      }
    }
  }
`
export const GET_ONE_PIPELINE = gql`
  query allPipelines($id: String) {
    allPipelines(id: $id) {
      edges {
        node {
          id
          name
          groupExclusivityHours
          organization {
            id
            name
          }
          stagePipelineSet {
            edges {
              node {
                id
                name
                order
                created
                updated
                stageType
              }
            }
          }
        }
      }
    }
  }
`

export const GET_PIPELINES_FILTERS = gql`
  query allPipelines($id: String) {
    allPipelines(id: $id) {
      edges {
        node {
          id
          name
          organization {
            id
            name
          }
          stagePipelineSet {
            edges {
              node {
                id
                name
                order
                stageType
              }
            }
          }
        }
      }
    }
  }
`

export const GET_MEMBERS_PIPELINE = gql`
  query pipelineById($id: String) {
    pipelineById(id: $id) {
      id
      name
      users {
        edges {
          node {
            id
            firstName
            lastName
            email
            cellphone
            rol
          }
        }
      }
    }
  }
`

export const GET_ALL_PIPELINES_FULL = gql`
  query allPipelinesFull {
    allPipelinesFull {
      edges {
        node {
          id
          name
          organization {
            id
            name
          }
          stagePipelineSet {
            edges {
              node {
                id
                name
                stageType
              }
            }
          }
        }
      }
    }
  }
`

export const GET_GROUPS_PIPELINE = gql`
  query pipelineById($id: String) {
    pipelineById(id: $id) {
      id
      name
      groups {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
